var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84199 8L11.7765 2.25982C12.0745 1.97161 12.0745 1.50435 11.7765 1.21615C11.4786 0.927949 10.9955 0.927952 10.6975 1.21615L4.22347 7.47817C3.92551 7.76637 3.92551 8.23363 4.22347 8.52183L10.6975 14.7838C10.9955 15.072 11.4786 15.0721 11.7765 14.7839C12.0745 14.4957 12.0745 14.0284 11.7765 13.7402L5.84199 8Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d3b0fe85.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84199 8L11.7765 2.25982C12.0745 1.97161 12.0745 1.50435 11.7765 1.21615C11.4786 0.927949 10.9955 0.927952 10.6975 1.21615L4.22347 7.47817C3.92551 7.76637 3.92551 8.23363 4.22347 8.52183L10.6975 14.7838C10.9955 15.072 11.4786 15.0721 11.7765 14.7839C12.0745 14.4957 12.0745 14.0284 11.7765 13.7402L5.84199 8Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d3b0fe85.svg";
export { ForwardRef as ReactComponent };